var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "sc-table",
    {
      staticClass: "tab-order-items",
      attrs: {
        data: _vm.invoiceOrderItems,
        loading: _vm.loadingInvoiceOrderItems,
        paginated: true,
        "backend-pagination": true,
        total: _vm.totalInvoiceOrderItems,
        "per-page": _vm.invoiceOrderItemsPagination.limit,
        "current-page": _vm.invoiceOrderItemsPagination.page
      },
      on: {
        "page-change": function(page) {
          return (_vm.invoiceOrderItemsPagination.page = page)
        }
      },
      scopedSlots: _vm._u([
        {
          key: "default",
          fn: function(props) {
            return [
              _c(
                "sc-table-column",
                {
                  attrs: {
                    field: "invoice-number",
                    label: "Item da fatura",
                    centered: false,
                    sortable: ""
                  }
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.invoice.reconciliation_invoice_number) +
                      "\n    "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "sc-table-column",
                {
                  attrs: {
                    field: "shipment_order_number",
                    label: "Pedido",
                    sortable: ""
                  }
                },
                [
                  props.row.shipment_order_number
                    ? _c(
                        "a",
                        {
                          attrs: {
                            href:
                              "/ng#/order-number/" +
                              props.row.shipment_order_number
                          }
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(props.row.shipment_order_number) +
                              "\n      "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !props.row.shipment_order_number
                    ? _c("span", [_vm._v("\n        Sem pedido\n      ")])
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _c(
                "sc-table-column",
                { attrs: { field: "description", width: 150, label: "CTe" } },
                [
                  !props.row.cte_number
                    ? _c("span", [_vm._v("Sem CTe")])
                    : _vm._e(),
                  _vm._v(" "),
                  props.row.cte_number
                    ? _c("div", { staticClass: "level is-paddingless" }, [
                        _c("div", { staticClass: "level-left" }, [
                          _vm._v(_vm._s(props.row.cte_number))
                        ]),
                        _vm._v(" "),
                        props.row.cte_file_attachment
                          ? _c("div", { staticClass: "level-right" }, [
                              _c("div", { staticClass: "field has-addons" }, [
                                _c("p", { staticClass: "control" }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "button is-info is-small",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function($event) {
                                          _vm.openFilesGallery(
                                            props.row.cte_file_attachment
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("sc-icon", {
                                        attrs: { icon: "eye", size: "is-small" }
                                      })
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("p", { staticClass: "control" }, [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "button is-primary is-small",
                                      attrs: {
                                        href: props.row.cte_file_attachment.url,
                                        target: "_blank",
                                        download: ""
                                      }
                                    },
                                    [
                                      _c("sc-icon", {
                                        attrs: {
                                          icon: "cloud-download-alt",
                                          size: "is-small"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              ])
                            ])
                          : _vm._e()
                      ])
                    : _vm._e()
                ]
              )
            ]
          }
        }
      ])
    },
    [
      _c(
        "template",
        { attrs: { slot: "empty" }, slot: "empty" },
        [_c("sc-table-empty")],
        1
      ),
      _vm._v(" "),
      _c(
        "template",
        { attrs: { slot: "bottom-left" }, slot: "bottom-left" },
        [
          _c("sc-table-per-page", {
            model: {
              value: _vm.invoiceOrderItemsPagination.limit,
              callback: function($$v) {
                _vm.$set(_vm.invoiceOrderItemsPagination, "limit", $$v)
              },
              expression: "invoiceOrderItemsPagination.limit"
            }
          })
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a42342a6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a42342a6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-recon/features/invoice-audit/pages/invoice-audit-detail/components/tab-order-items/TabInvoiceAuditDetailOrderItems.vue
// module id = null
// module chunks = 